import { Box, Typography, Stack, Button, Divider, Paper } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { IOSStatusBar } from "./IOSStatusBar";

export default function WhatsAppAdsPreviewIOS({ data }) {
  const {
    header = {},
    body,
    footer,
    buttons = [],
    brand = "Business Name",
    adLabel = "Sponsored",
    callingPermission = false,
  } = data;

  const media = header.media;

  console.log(data);

  const SAMPLE_THUMBNAILS = {
    IMAGE: "https://via.placeholder.com/400x300?text=Image+Preview",
    VIDEO: "https://via.placeholder.com/400x300?text=Video+Preview",
    DOCUMENT: "https://via.placeholder.com/400x300?text=Document+Preview",
  };

  return (
    <Box
      sx={{
        height: "100%",
        bgcolor: "#EFEAE2",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <IOSStatusBar />

      <Box
        sx={{
          height: 56,
          px: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 1.2,
          bgcolor: "#fff",
          borderBottom: "1px solid #e5e7eb",
          mt: 3,
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            bgcolor: "#25D366",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
          }}
        >
          {brand[0]}
        </Box>
        <Box>
          <Typography fontSize={14} fontWeight={600}>
            {brand}
          </Typography>
          <Typography fontSize={11} color="text.secondary">
            {adLabel}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flex: 1, px: 1.2, py: 1, overflowY: "auto" }}>
        <Box sx={{ textAlign: "center", my: 1 }}>
          <Typography
            fontSize={11}
            color="text.secondary"
            sx={{
              px: 1.5,
              py: 0.4,
              bgcolor: "#e5e7eb",
              borderRadius: 10,
              display: "inline-block",
            }}
          >
            Today
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          <Box
            sx={{
              maxWidth: "92%",
              bgcolor: "#fff",
              borderRadius: "18px 18px 18px 6px",
              overflow: "hidden",
              boxShadow: "0 1px 1px rgba(0,0,0,0.18)",
            }}
          >
            {media && (
              <Box
                sx={{
                  height: 190,
                  bgcolor: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {media.type === "IMAGE" && (
                  <img
                    src={
                      media.file
                        ? URL.createObjectURL(media.file)
                        : media.url || SAMPLE_THUMBNAILS.IMAGE
                    }
                    alt="image preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}

                {media.type === "VIDEO" && (
                  <>
                    <img
                      src={media.url || SAMPLE_THUMBNAILS.VIDEO}
                      alt="video preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <PlayArrowRoundedIcon
                      sx={{
                        fontSize: 64,
                        color: "#fff",
                        position: "absolute",
                      }}
                    />
                  </>
                )}

                {/* DOCUMENT */}
                {media.type === "DOCUMENT" && (
                  <Stack alignItems="center" spacing={0.5}>
                    <img
                      src={SAMPLE_THUMBNAILS.DOCUMENT}
                      alt="document preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: 0.85,
                      }}
                    />
                    <DescriptionRoundedIcon
                      sx={{
                        fontSize: 56,
                        color: "#fff",
                        position: "absolute",
                      }}
                    />
                  </Stack>
                )}
              </Box>
            )}

            <Box sx={{ p: 1.5 }}>
              {/* Calling Permission template layout */}
              {callingPermission ? (
                <Box>
                  {/* Header text if provided */}
                  {header.text && (
                    <Typography fontSize={13} fontWeight={600} color="#1e293b" sx={{ mb: 0.5 }}>
                      {header.text}
                    </Typography>
                  )}

                  {/* Body text */}
                  <Typography fontSize={13} color="#1e293b" sx={{ mb: 1.5 }}>
                    {body || "Hello"}
                  </Typography>

                  {/* Time indicator */}
                  <Typography
                    sx={{
                      fontSize: 10,
                      color: "#94a3b8",
                      textAlign: "right",
                      mb: 1,
                    }}
                  >
                    10:09
                  </Typography>

                  {/* Phone icon section */}
                  <Box sx={{ display: "flex", gap: 1.5 }}>
                    {/* Phone icon */}
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        bgcolor: "#e0f2fe",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <PhoneRoundedIcon sx={{ fontSize: 16, color: "#0ea5e9" }} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography fontSize={13} fontWeight={600} color="#1e293b" sx={{ mb: 0.5 }}>
                        Can {"{BIZ_NAME}"} call you?
                      </Typography>
                      <Typography fontSize={12} color="#64748b" sx={{ lineHeight: 1.5 }}>
                        You can update your preference at any time in the business profile.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Stack spacing={0.8}>
                  {/* Catalogue header with icon box */}
                  {header.text && header.subtext && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                        p: 1,
                        borderRadius: 1,
                        bgcolor: "#f0f0f0",
                      }}
                    >
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: 1,
                          bgcolor: "#e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <DescriptionRoundedIcon sx={{ fontSize: 18, color: "#666" }} />
                      </Box>
                      <Box>
                        <Typography fontSize={12} fontWeight={600} color="#333">
                          {header.text}
                        </Typography>
                        <Typography fontSize={10} color="text.secondary">
                          {header.subtext}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {/* Regular text header (no subtext) */}
                  {header.text && !header.subtext && (
                    <Typography fontSize={14} fontWeight={600}>
                      {header.text}
                    </Typography>
                  )}

                  <Typography fontSize={15} whiteSpace="pre-line">
                    {body || "Your WhatsApp ad message will appear here"}
                  </Typography>

                  {footer && (
                    <Typography fontSize={11} color="text.secondary">
                      {footer}
                    </Typography>
                  )}
                </Stack>
              )}
            </Box>
          </Box>
        </Box>

        {buttons.length > 0 && (
          callingPermission ? (
            /* Calling permission button style */
            <Box sx={{ mt: 1, maxWidth: "92%" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.5,
                  py: 1,
                  color: "#0ea5e9",
                  cursor: "pointer",
                }}
              >
                <Typography fontSize={14} fontWeight={500}>
                  {buttons[0]?.text || "Choose preference"}
                </Typography>
                <KeyboardArrowDownRoundedIcon sx={{ fontSize: 18 }} />
              </Box>
            </Box>
          ) : (
            <Stack spacing={0} mt={0.8} maxWidth="92%">
              {buttons.map((b, i) => {
                // Get icon based on button type
                const getButtonIcon = () => {
                  switch (b.type) {
                    case "CALL":
                      return <CallRoundedIcon />;
                    case "URL":
                      return <OpenInNewRoundedIcon />;
                    case "COPY":
                      return <ContentCopyRoundedIcon />;
                    case "QUICK_REPLY":
                      return <ReplyRoundedIcon />;
                    default:
                      return <OpenInNewRoundedIcon />;
                  }
                };

                return (
                  <Paper
                    key={i}
                    sx={{
                      bgcolor: "#fff",
                      borderRadius: i === buttons.length - 1 ? "0 0 16px 16px" : 0,
                    }}
                  >
                    <Divider />
                    <Button
                      fullWidth
                      startIcon={getButtonIcon()}
                      sx={{
                        py: 1.2,
                        color: "#007AFF",
                        textTransform: "none",
                        fontWeight: 500,
                      }}
                    >
                      {b.text}
                    </Button>
                  </Paper>
                );
              })}
            </Stack>
          )
        )}
      </Box>
    </Box>
  );
}
